var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXlsO(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xls-o_svg__xls-o_svg__Canvas",
    transform: "translate(-440 -3129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "xls-o_svg__xls-o_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "xls-o_svg__xls-o_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xls-o_svg__xls-o_svg__path0_fill",
    transform: "translate(457.048 3133.19)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "xls-o_svg__xls-o_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#xls-o_svg__xls-o_svg__path1_fill",
    transform: "translate(440 3129)",
    fill: "#FFFFFF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "xls-o_svg__xls-o_svg__path0_fill",
    d: "M 5.68261 0L 0 0L 0 14.6667L 5.68261 14.6667L 5.68261 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "xls-o_svg__xls-o_svg__path1_fill",
    d: "M 0 18.3333L 15.9113 22L 15.9113 0L 0 3.66667L 0 18.3333ZM 3.97783 6.11111L 6.50659 6.11111L 7.92725 8.82444L 9.40473 6.11111L 11.8767 6.11111L 9.29107 9.99778L 12.1324 14.5689L 9.60362 14.5689L 7.92725 11.3422L 6.27929 14.5689L 3.80735 14.5689L 6.56342 10.0711L 3.97783 6.11111Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsO);
export default __webpack_public_path__ + "static/media/xls-o.6d25e3aecb9dd68624d3f0e2b852eac3.svg";
export { ForwardRef as ReactComponent };